/**
 * Sales API
 * CRUD operations for the Sales module
 */

import { apiClient } from "./apiClient";

export const salesAPI = {
  // List sales with pagination, search, filters
  listSales: (organizationId, params = {}) =>
    apiClient.get(`/sales/org/${organizationId}/`, { params }),

  // Fetch inventory items for the product picker on the New/Edit Sale form.
  // Returns items with remaining_quantity > 0 by default; pass params to override.
  listInventoryProducts: (organizationId, params = {}) =>
    apiClient.get(`/inventory/items/org/${organizationId}/`, {
      params: { page_size: 200, sort_by: "product_name", sort_dir: "asc", ...params },
    }),

  // Get a single sale with items
  getSale: (organizationId, saleId) =>
    apiClient.get(`/sales/org/${organizationId}/${saleId}/`),

  // Create a new sale
  createSale: (organizationId, payload) =>
    apiClient.post(`/sales/org/${organizationId}/create/`, payload),

  // Update an existing sale
  updateSale: (organizationId, saleId, payload) =>
    apiClient.patch(`/sales/org/${organizationId}/${saleId}/`, payload),

  // Delete a sale
  deleteSale: (organizationId, saleId) =>
    apiClient.delete(`/sales/org/${organizationId}/${saleId}/`),

  // Get sales summary / analytics
  getSummary: (organizationId) =>
    apiClient.get(`/sales/org/${organizationId}/summary/`),

  // Get next auto-generated invoice number
  getNextInvoice: (organizationId) =>
    apiClient.get(`/sales/org/${organizationId}/next-invoice/`),

  // Export sales as CSV
  exportSales: (organizationId, params = {}) =>
    apiClient.get(`/sales/org/${organizationId}/export/`, {
      params,
      responseType: "blob",
    }),

  // Download invoice PDF for a sale
  downloadInvoicePDF: (organizationId, saleId) =>
    apiClient.getBlob(`/sales/org/${organizationId}/${saleId}/invoice-pdf/`),
};
